import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-camera 384",
  "use": "icon-camera 384-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-camera 384\"><path d=\"M810.667 256a64 64 0 0 1 64 64v426.667a64 64 0 0 1-64 64H213.333a64 64 0 0 1-64-64V320a64 64 0 0 1 64-64h597.334z m0 64H213.333v426.667h597.334V320zM512 384a149.333 149.333 0 1 1 0 298.667A149.333 149.333 0 0 1 512 384z m0 64a85.333 85.333 0 1 0 0 170.667A85.333 85.333 0 0 0 512 448z m298.667-298.667v64H512v-64h298.667z\" p-id=\"25055\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol